import { Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { JourneyStep } from "../../helpers/form-summary"
import { ReviewJourney } from "../review/ReviewJourney"

interface ActivationDialogProps {
  open: boolean
  sentence: string
  steps: JourneyStep[]
  activating: boolean
  onConfirm: () => void
  onCancel: () => void
  /** Runs once the dialog has closed and handed focus back. */
  afterClose?: () => void
}

/** Marks the review dialog's wrapper, to tell it from any other open dialog. */
export const REVIEW_DIALOG_CLASS = "automation-review-dialog"

// The last look before an automation goes live: the rule and its journey,
// from the same values that are about to be saved.
export function ActivationDialog({
  open,
  sentence,
  steps,
  activating,
  onConfirm,
  onCancel,
  afterClose
}: ActivationDialogProps) {
  const { t } = useTranslation()
  return (
    <Modal
      open={open}
      centered
      rootClassName={"automation-scope"}
      wrapClassName={REVIEW_DIALOG_CLASS}
      title={t("settingsAutomation.builder.activation.title")}
      okText={t("settingsAutomation.builder.activation.activate")}
      cancelText={t("settingsAutomation.builder.activation.keepEditing")}
      confirmLoading={activating}
      cancelButtonProps={{ disabled: activating }}
      closable={!activating}
      maskClosable={!activating}
      keyboard={!activating}
      onOk={onConfirm}
      onCancel={onCancel}
      afterClose={afterClose}
    >
      <div className={"flex flex-col gap-3"}>
        <p className={"m-0"}>{sentence}</p>
        <ReviewJourney steps={steps} />
      </div>
    </Modal>
  )
}
